import React from 'react';
import clsx from 'clsx';
import { PulseProps } from './pulse-animation.types';
import '@/assets/styles/components/pulse-animation.styles.scss';

const Pulse: React.FC<PulseProps> = ({ children, isActive = false, color = '#63B0A1', size = 200, className = '', ...props }) => {
	const circleSize = size * 0.7; // İç daire boyutu ana boyutun %70'i olsun

	return (
		<div
			className={clsx('pulse-container', isActive && 'pulse-container--active', className)}
			style={{
				width: size,
				height: size
			}}
			{...props}>
			<div
				className="pulse-circle"
				style={
					{
						'--pulse-color': color,
						width: circleSize,
						height: circleSize
					} as React.CSSProperties
				}
			/>
			<div
				className="pulse-circle"
				style={
					{
						'--pulse-color': color,
						width: circleSize,
						height: circleSize
					} as React.CSSProperties
				}
			/>
			<div
				className="pulse-circle"
				style={
					{
						'--pulse-color': color,
						width: circleSize,
						height: circleSize
					} as React.CSSProperties
				}
			/>
			{children}
		</div>
	);
};

export default Pulse;
